import ApiClient from './ApiClient'

const API_NAME = 'WeConnect'
const client = new ApiClient(API_NAME)

export default {
  setting(businessId) {
    return client.get(`/business/${businessId}/schedule-setting`)
  },

  show(businessId, year, month) {
    return client.get(`/business/${businessId}/schedule/${year}/${month}`)
  },
}
